import { render, staticRenderFns } from "./TableJobDetail.vue?vue&type=template&id=55db172f&scoped=true&"
import script from "./TableJobDetail.vue?vue&type=script&lang=js&"
export * from "./TableJobDetail.vue?vue&type=script&lang=js&"
import style0 from "./TableJobDetail.vue?vue&type=style&index=0&lang=css&"
import style1 from "./TableJobDetail.vue?vue&type=style&index=1&id=55db172f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55db172f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VChip,VDataTable,VIcon})
